import React from 'react';
import moment from 'moment';
import {
  SubTitle,
  SubTitleWrapper,
  SubTitle1,
  SubTitle2,
} from 'styles/pages/staples-bulk-orders';

const SubHeader = ({ state }) => {
  return (
    !!state?.orderPdfData?.orderPO?.length && (
      <SubTitle style={{ gridTemplateColumns: '1fr 1fr 1fr 1fr' }}>
        <SubTitleWrapper>
          <SubTitle1>{state?.orderPdfData?.poCustomer}</SubTitle1>
          <SubTitle2>PO: {state?.orderPdfData?.orderPO[0]}</SubTitle2>
        </SubTitleWrapper>
        <SubTitleWrapper>
          <SubTitle1>Ship To</SubTitle1>
          {state?.orderPdfData?.shipTo?.map((o) => (
            <SubTitle2 key={o}>{o}</SubTitle2>
          ))}
        </SubTitleWrapper>

        <SubTitleWrapper>
          <SubTitle1>Ship From Account</SubTitle1>
          {state?.orderPdfData?.shippingAccount
            ? state?.orderPdfData?.shippingAccount[0]
            : null}
        </SubTitleWrapper>

        <SubTitleWrapper>
          <SubTitle1>Status</SubTitle1>
          <SubTitle2>{state?.status}</SubTitle2>
          {state?.ipromoteuShipDate && (
            <>
              <SubTitle1>IPromoteU Ship Date</SubTitle1>
              <SubTitle2>
                {moment(state?.ipromoteuShipDate).format('DD/MM/YYYY')}
              </SubTitle2>
            </>
          )}
        </SubTitleWrapper>
      </SubTitle>
    )
  );
};

export default SubHeader;
